__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-common/v5_18_0/";